import List from "./List";
import Document from "./Document";

export default { List, Document };
